import * as React from 'react';
import FormValidationDisplay from './ValidationDisplay';
import Button from './Button';

interface Props {
    children?: React.ReactNode;
    wasFormValidated: boolean;
    inBootstrapColumn: boolean;
    submitButtonText: string;
    errorMessage?: string;
    successMessage?: string;
    onSubmit: () => void;
    onFormValidated: () => void;
    divClassname?: string;
    additionalButtons?: React.ReactNode;
    additionalSubmitButtonClassname?: string;
    buttonGroupClassName?: string;
    disabled?: boolean;
}

const Form = (props: Props) => {
    let formControl: HTMLFormElement | null;

    const handleSubmit = (e: React.SyntheticEvent<HTMLFormElement>) => {
        e.preventDefault();
        e.stopPropagation();

        if (formControl !== null) {
            props.onFormValidated();
            if (formControl.checkValidity() === true) {
                props.onSubmit();
            }
        }
    };

    return (
        <div className={props.divClassname}>
            <FormValidationDisplay
                errorMessage={props.errorMessage}
                successMessage={props.successMessage}
            />
            <form
                ref={form => (formControl = form)}
                noValidate={true}
                className={props.wasFormValidated ? 'was-validated' : ''}
                onSubmit={handleSubmit}
            >
                {props.children}
                <div className={props.buttonGroupClassName || 'btn-group'} role="group">
                    <Button
                        text={props.submitButtonText}
                        type={'submit'}
                        addlClassName={`btn-primary ${props.additionalSubmitButtonClassname || ''}`}
                        disabled={props.disabled}
                    />
                    {props.additionalButtons}
                </div>
            </form>
        </div>
    );
};

export default Form;


// WEBPACK FOOTER //
// ./src/components/common/form/Form.tsx